export const SINGLE = "Single User";
export const UNLIMITED = "Unlimited";
